export default __webpack_public_path__ + "static/media/banner-02.deba5511.jpg";